export class ValidatedAddressInfo {

  addressType!: string;
  line1!: string;
  line2!: string;
  line3!: string;
  city!: string;
  region!: string;
  country!: string;
  postalCode!: string;
  latitude!: number;
  longitude!: number;

}
